module.exports = __webpack_public_path__ + "img/address-foreign.8eeb9f97.svg";